/*
  Global Dayjs plugin setup

  Why:
  - Ant Design's rc-picker expects certain Dayjs plugins (e.g., weekday, localeData,
    weekOfYear/weekYear). Without them, runtime errors like "clone.weekday is not a function"
    can occur after interacting with DatePicker/RangePicker.

  How:
  - Extend Dayjs once here and import this module early (in src/main.tsx).
  - This ensures a single, globally-extended Dayjs instance across the app and avoids
    plugin-related runtime/type mismatches.
*/
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import isBetween from "dayjs/plugin/isBetween";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(isBetween);
dayjs.extend(relativeTime);

export {};

